/**
 * The one-click way back to where a record came from (E4, spec D25 §9.4):
 * an icon link to the in-product thread, used on register rows, task detail
 * headers and the entry step's card. Renders nothing for a record born
 * without a conversation.
 */
import { Link } from 'react-router-dom'
import { Mail, MessageSquare, Users } from 'lucide-react'
import { cn } from '@/utils'
import { sourceLabel, useSourceHref, type SourceRef } from './sourceText'

export function SourceLink({ source, className }: { source: SourceRef | null | undefined; className?: string }) {
  const href = useSourceHref(source)
  if (!source || !href) return null
  const Icon = source.kind === 'email' ? Mail : source.kind === 'whatsapp-group' ? Users : MessageSquare
  const label = `Open the ${sourceLabel(source.kind).toLowerCase()}`
  return (
    <Link
      to={href}
      aria-label={label}
      title={label}
      onClick={e => e.stopPropagation()}
      className={cn('inline-flex items-center text-muted-foreground hover:text-primary', className)}
    >
      <Icon className="w-3.5 h-3.5" />
    </Link>
  )
}
